module.exports = __webpack_public_path__ + "static/media/phone_t.d49b8b8f.png";